import React, { useState } from "react";
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  Avatar,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import { Clear } from "@mui/icons-material";

const SearchBar = ({
  query,
  setQuery,
  selectedMerchant,
  setSelectedMerchant,
  merchants,
  handleSearch,
  filteredData,
}) => {
  const [inputValue, setInputValue] = useState(query);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearchClick = async () => {
    handleSearch(inputValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  const handleClearFilter = () => {
    setSelectedMerchant("");
  };

  // Function to truncate text
  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  return (
    <>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <TextField
          label="Search Product"
          variant="outlined"
          size={isMobile ? "small" : "large"}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          style={{ flex: 1 }}
        />

        <Button
          variant="contained"
          color="primary"
          size={isMobile ? "medium" : "large"}
          onClick={handleSearchClick}
          style={{
            flex: "0 0 auto",
          }}
        >
          Search
        </Button>
      </div>
      {filteredData && filteredData.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
            marginBottom: "10px",
            width: "100%",
          }}
        >
          <FormControl
            variant="outlined"
            size={isMobile ? "small" : "large"}
            style={{ width: "50%", maxWidth: "300px" }}
          >
            <Select
              value={selectedMerchant}
              onChange={(e) => setSelectedMerchant(e.target.value)}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) return "Select Store";
                const merchant = merchants.find((m) => m.name === selected);
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      maxWidth: "100%",
                    }}
                  >
                    <Avatar
                      alt={merchant?.name}
                      src={merchant?.logo}
                      style={{
                        width: 24,
                        height: 24,
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {truncateText(merchant?.name || "", isMobile ? 15 : 20)}
                    </Typography>
                  </div>
                );
              }}
            >
              {merchants.map((merchant, index) => (
                <MenuItem key={index} value={merchant.name}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: "100%",
                    }}
                  >
                    <Avatar
                      alt={merchant.name}
                      src={merchant.logo}
                      style={{
                        width: 24,
                        height: 24,
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {merchant.name}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Clear Filter Button */}
          {selectedMerchant && (
            <Button
              variant="outlined"
              color="error"
              size={isMobile ? "small" : "medium"}
              onClick={handleClearFilter}
              startIcon={<Clear />}
              sx={{
                minWidth: "auto",
                padding: isMobile ? "4px 8px" : "6px 16px",
                height: isMobile ? "32px" : "40px",
                borderRadius: "4px",
                textTransform: "none",
              }}
            >
              Clear Filter
            </Button>
          )}
        </Box>
      )}
    </>
  );
};

export default SearchBar;
